import React from 'react'
import {Modal} from 'react-bootstrap'

interface ConnectionModalProps {
  isVisible: boolean
  onRetry: () => void
}

const ConnectionModal: React.FC<ConnectionModalProps> = ({isVisible, onRetry}) => {
  return (
    <Modal
      show={isVisible}
      centered
      size="sm"
      contentClassName="custom-error-modal-content"
      backdrop="static"
      keyboard={false}
    >
      <div className="modal-content" style={{borderRadius: '8px'}}>
        <div className="modal-body p-0">
          <div className="text-center p-5">
            {/* Error Icon */}
            <div className="mb-4">
              <div 
                className="d-inline-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#FFE2E2'
                }}
              >
                <i className="bi bi-wifi-off fs-1 text-danger"></i>
              </div>
            </div>
            
            {/* Error Title */}
            <h4 className="mb-3 fw-bold">Connection Error</h4>
            
            {/* Error Message */}
            <p className="mb-4 text-gray-600">Please check your internet connection.</p>
            
            {/* Retry Button */}
            <button
              className="btn btn-primary px-6 py-2"
              onClick={onRetry}
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ConnectionModal 